const convert_name = ({ name }) => {
  // Hàm để chuyển đổi từ dạng dấu sang không dấu
  const removeAccents = (str) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Loại bỏ dấu
      .toLowerCase()
  }

  // Hàm để chuyển đổi từ kiểu chữ thường thành title case với chữ cái đầu của mỗi từ viết hoa
  const toTitleCaseR = (str) => {
    return str
      .split(' ') // Tách thành mảng các từ
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Viết hoa chữ cái đầu tiên của mỗi từ
      .join(' ') // Nối lại thành chuỗi với khoảng trắng giữa các từ
  }

  // Xử lý tên
  const trimmedName = name
    .trim() // Loại bỏ khoảng trắng đầu và cuối
    .replace(/\s+/g, ' ') // Thay thế nhiều khoảng trắng liên tiếp thành một khoảng trắng đơn
    .replace(/^\s+|\s+$/g, '') // Loại bỏ khoảng trắng đầu/cuối

  // Chuyển đổi tên sang không dấu và sau đó sang title case
  const convertedName = toTitleCaseR(removeAccents(trimmedName))

  return convertedName
}
export const convert_name_UNICODE = (name) => {
  // Hàm để chuyển đổi từ dạng dấu sang không dấu

  // Hàm để chuyển đổi từ kiểu chữ thường thành title case với chữ cái đầu của mỗi từ viết hoa

  // Xử lý tên
  const trimmedName = name
    .trim() // Loại bỏ khoảng trắng đầu và cuối
    .replace(/\s+/g, ' ') // Thay thế nhiều khoảng trắng liên tiếp thành một khoảng trắng đơn
    .replace(/^\s+|\s+$/g, '') // Loại bỏ khoảng trắng đầu/cuối

  // Chuyển đổi tên sang không dấu và sau đó sang title case
  const convertedName = toTitleCase(trimmedName)

  return convertedName
}
export const toTitleCase = (str) => {
  return str
    .toLowerCase() // Chuyển tất cả thành chữ thường trước
    .split(' ') // Tách thành mảng các từ
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : '')) // Viết hoa chữ cái đầu tiên của mỗi từ
    .join(' ') // Nối lại thành chuỗi với khoảng trắng giữa các từ, bao gồm khoảng trắng cuối
}

const get_first_char_of_last_word = (str) => {
  if (!str) return ''
  // Tách chuỗi thành các từ và lấy từ cuối cùng
  const words = str.trim().split(' ')
  const lastWord = words[words.length - 1]
  // Lấy ký tự đầu tiên và chuyển đổi thành chữ in hoa
  return lastWord.charAt(0).toUpperCase()
}

const get_microsoft_user_id = (email) => {
  const userId = email.match(/^[^@]+/)[0]
  return userId
}

const remove_accents = (str) => {
  const accents =
    'àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ'
  const noAccents =
    'aaaaaaaaaaaaaaaaaeeeeeeeeeeiiiiioooooooooooooooooouuuuuuuuuuuyyyyyd'

  return str
    .split('')
    .map((char) => {
      const index = accents.indexOf(char)
      return index === -1 ? char : noAccents[index]
    })
    .join('')
}
function convertUnixToDate(unixTimestamp) {
  const date = new Date(unixTimestamp) // Đối với timestamp có milliseconds
  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const year = date.getUTCFullYear()
  return `${day}-${month}-${year}`
}
function formatTimestampToDateTime(timestamp) {
  const dateObj = new Date(timestamp)

  // Lấy các thành phần ngày, tháng, năm, giờ, phút, giây
  const hours = String(dateObj.getHours()).padStart(2, '0')
  const minutes = String(dateObj.getMinutes()).padStart(2, '0')
  const seconds = String(dateObj.getSeconds()).padStart(2, '0')
  const day = String(dateObj.getDate()).padStart(2, '0')
  const month = String(dateObj.getMonth() + 1).padStart(2, '0') // Tháng bắt đầu từ 0
  const year = dateObj.getFullYear()

  // Kết hợp thành chuỗi theo định dạng yêu cầu
  return `${hours}:${minutes}:${seconds} ${day}/${month}/${year}`
}
function convertFilterDateFormat(dateString) {
  if (!dateString) {
    return undefined
  }
  const [year, month, day] = dateString.split('-')
  return `${day}/${month}/${year}`
}
function convertFilterDateFixed(dateString) {
  if (!dateString) {
    return undefined
  }
  const [year, month, day] = dateString.split('-')
  const preDay = convertFilterDateFormat(
    getPreDay({
      day: Number(day),
      month: Number(month),
      year: Number(year),
    })
  )
  const nextDay = convertFilterDateFormat(
    getNextDay({
      day: Number(day),
      month: Number(month),
      year: Number(year),
    })
  )
  return `${preDay}-${nextDay}`
}

const getPreDay = ({ day, month, year }) => {
  const dayInMonth = [
    31,
    (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ]
  if (day > 1 && day <= dayInMonth[month - 1]) {
    return `${year}-${month}-${day - 1}`
  } else {
    if (month > 1 && month <= 12) {
      return `${year}-${month - 1}-${dayInMonth[month - 2]}`
    } else {
      return `${year - 1}-12-31`
    }
  }
}
const getNextDay = ({ day, month, year }) => {
  const dayInMonth = [
    31,
    (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ]
  if (day >= 1 && day < dayInMonth[month - 1]) {
    return `${year}-${month}-${day + 1}`
  } else {
    if (month >= 1 && month < 12) {
      return `${year}-${month + 1}-1`
    } else {
      return `${year}-1-1`
    }
  }
}

const getVietTypeDate = () => {
  const date = new Date()

  let day = date.getDate()
  let month = date.getMonth() + 1
  let year = date.getFullYear()

  return `${day}/${month}/${year}`
}
const addDefaultDropDown = (options) => {
  return [
    {
      value: '',
      label: 'Tất cả',
    },
    ...options,
  ]
}
export {
  convert_name,
  get_first_char_of_last_word,
  get_microsoft_user_id,
  remove_accents,
  convertUnixToDate,
  formatTimestampToDateTime,
  convertFilterDateFormat,
  getVietTypeDate,
  addDefaultDropDown,
  convertFilterDateFixed,
}
